import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-div-simple',
	templateUrl:'./DivSimplePluginCompPage.html',
	styles: [],
	styleUrls:['./DivSimplePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DivSimplePluginCompPage
{
	mdContent_904 = `\`\`\`java
import com.jwebmp.core.base.html.DivSimple;
\`\`\``;
	mdContent_905 = `\`\`\`java
DivSimple()
\`\`\``;
	mdContent_906 = `\`\`\`java
DivSimple(String text)
\`\`\``;
	mdContent_907 = `\`\`\`java
DivSimple&lt;?&gt; div = new DivSimple&lt;&gt;();
div.setText("Hello World");
div.setID("myDiv");
div.addClass("container");
div.add(new Paragraph&lt;&gt;().setText("Child paragraph"));
\`\`\``;
}
